"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableStartButton = void 0;
const disableStartButton = (termsApproved, showCheckbox = false) => {
    return showCheckbox && !termsApproved;
};
exports.disableStartButton = disableStartButton;
